import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const fetchModuleQueryTestSuite = async (prodid) => {
  if (!prodid) {
    return [];
  }
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=searchModDropDown&companyid=${user.companyid}`,
    {
      params: { prodid },
    },
  );

  return response.data;
};

const useMoveModuleQuery = (initialProdId = null) => {
  const query = useQuery({
    queryKey: ["moveModuleQuery", initialProdId],
    queryFn: () => fetchModuleQueryTestSuite(initialProdId),
    enabled: !!initialProdId,
    retry: true,
    staleTime: 0,
    refetchInterval: false,
    refetchIntervalInBackground: false,
  });

  const refetchWithParams = (moduleParams) => {
    query.refetch();
  };

  return {
    ...query,
    refetchWithParams,
  };
};

export default useMoveModuleQuery;
